// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container___NzEw","title":"Card_title__VK69f","content":"Card_content__byY26","footer":"Card_footer__feNU0"};